export const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;
